import React, { useContext } from 'react';
import PageProps from '@leuven2030/food/Page/PageProps';
import PagePaths from '@leuven2030/food/Page/PagePaths';
import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';
import { gql } from '@apollo/client';
import ContentCover from '@leuven2030/framework/Content/ContentCover';
import Page, { PageContext } from '@leuven2030/framework/Page/Page';
import ContentPrismic from '@leuven2030/framework/Content/ContentPrismic';
import { StyleContent } from '@leuven2030/food/styles/general';
import ContentVideo from '@leuven2030/framework/Content/ContentVideo';
import ContentQuote from '@leuven2030/framework/Content/ContentQuote';
import ContentFeature from '@leuven2030/framework/Content/ContentFeature';
import { useRouter } from 'next/router';
import PageFallback from '@leuven2030/food/Page/PageFallback';
import Page404 from '@leuven2030/food/Page/Page404';
import 'twin.macro';
import ContentList from '@leuven2030/food/Content/ContentList';
import ContentAction from '@leuven2030/framework/Content/ContentAction';

const InfoPage = Page(() => {
  const {
    prismic: { info_page }
  } = useContext(PageContext);

  const router = useRouter();

  if (router.isFallback) {
    return <PageFallback />;
  }

  if (!info_page) {
    return <Page404 />;
  }

  const { title, cover, description, body } = info_page;
  return (
    <PageLayoutDefault>
      <ContentCover image={cover} title={title} />
      {/* <div tw="bg-primary-400 py-12">
        <div css={StyleContent}>
          <div tw="flex flex-col space-y-6 sm:(flex-row items-start justify-between space-x-3 space-y-0) w-full">
            <div tw="space-y-4">
              <h1 tw="text-white font-black text-3xl sm:text-4xl">{title}</h1>
              <p tw="text-white text-lg lowercase">{description}</p>
            </div>
          </div>
        </div>
      </div> */}
      <ContentPrismic
        tw=" py-12"
        css={StyleContent}
        slices={body}
        SliceComponents={[
          ContentVideo,
          ContentQuote,
          ContentFeature,
          ContentList,
          ContentAction
        ]}
      />
    </PageLayoutDefault>
  );
});

export const getStaticProps = PageProps({
  prismic: {
    query: gql`
      query($uid: String!) {
        info_page(uid: $uid, lang: "nl-be") {
          title
          description
          cover {
            ... on _ImageLink {
              url
            }
          }
          body {
            ... on Info_pageBodyRich_text {
              type
              primary {
                text
              }
            }

            ... on Info_pageBodyQuote {
              type
              primary {
                text
                image {
                  ... on _ImageLink {
                    url
                  }
                }
                name
                function
              }
            }

            ... on Info_pageBodyAction {
              type
              primary {
                label
                link {
                  ... on _ExternalLink {
                    url
                  }
                  ... on _Document {
                    _meta {
                      type
                      uid
                    }
                  }
                }
              }
            }

            ... on Info_pageBodyList {
              type
              primary {
                indentation
                type
              }
              fields {
                text
              }
            }

            ... on Info_pageBodyFeature {
              type
              primary {
                image {
                  ... on _ImageLink {
                    url
                  }
                }
                title
              }
              fields {
                text
              }
            }
          }
        }
      }
    `,
    onContext: ({ params }, options) => {
      const { uid } = params || {};
      options.setVariables({
        uid
      });
    }
  }
});

export const getStaticPaths = PagePaths({
  type: 'info_page'
});

export default InfoPage;
